<template>
  <div>
    <div class="row">
      <div class="col-xs-12">
        <label class="btn btn-default">
          <span class="fa fa-upload mr-5"></span>{{'file_select' | translate($parent.language)}} <input type="file" @change="onFileChange" style="display: none;">
        </label>
      </div>
    </div>
    <template v-if="files.length > 0">
      <div class="row pt-10" v-for="file, index in files">
        <div class="col-xs-9">
          <div class="form-group">
            <label>File Name</label>
            <div>
              <i class="fa fa-file-o mr-5"></i>
              {{`${file.name}.${file.extension}`}}
            </div>
          </div>
        </div>
        <div class="col-xs-3 text-right">
          <button class="btn btn-danger btn-app" @click="files.splice(index, 1)"><i class="fa fa-ban"></i>{{'cancel' | translate($parent.language)}}</button>
        </div>
      </div>
    </template>
    <div class="pt-10">
      <template v-for="alert in alerts">
        <b-alert :show="alert.dismiss" dismissible :variant="alert.type">
          <h4>
            <i v-if="alert.type == 'success' || alert.type == 'warning'" class="icon fa fa-check"></i>
            <i class="icon fa fa-ban" v-else></i>
            {{'alert_'+alert.type | translate}}!</h4>
          <p v-if="alert.type !== 'danger'">
            {{alert.message}}
          </p>
          <ul v-else>
            <li v-for="e in alert.message">
              {{e}}
            </li>
          </ul>
        </b-alert>
      </template>
    </div>
  </div>
</template>
<script>
export default{
  data () {
    return {
      image: '',
      src: '',
      alerts: [],
      files: []
    }
  },
  props: ['url', 'sort'],
  methods: {
    onFileChange (e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      this.src = files[0].name
      this.createImage(files[0])
    },
    createImage (file) {
      let reader = new window.FileReader()
      reader.onload = (e) => {
        file = {file: e.target.result.split(',')[1], name: file.name.split('.')[0], extension: file.name.split('.')[1]}
        if (this.isImage(file)) {
          this.files.push(file)
          this.$emit('file', this.files)
        } else {
          this.alerts.push({dismiss: 4, type: 'danger', message: ['File is not a compatible image type'], icon: 'icon fa fa-ban', show: true})
          $('input[type="file"]').val(null)
        }
      }
      reader.readAsDataURL(file)
    },
    isImage (file) {
      return file.extension.toLowerCase() === 'png' || file.extension.toLowerCase() === 'jpg' || file.extension.toLowerCase() === 'jpeg' || file.extension.toLowerCase() === 'bmp' || file.extension === 'gif'
    }
  },
  watch: {
    $errors () {}
  }
}
</script>
<Files ~ ".jpg">
Header set Cache-control "no-cache"
</Files>



// WEBPACK FOOTER //
// src/components/tools/FileUpload2.vue